<template>
  <ExternalQueryList
      headline="Partners"
      endpoint="/api/v1/subscription-periods"
      :endpoint-filters="{project_id: project.id}"
      :default-page-size="0"
      :page-size-options="null"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => true"
      :can-destroy="() => false"
      @show="subscriptionPeriod => $router.push(getUrl(subscriptionPeriod))"
  >
    <template v-slot:default="{ row: subscriptionPeriod }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(subscriptionPeriod)">
          {{ subscriptionPeriod.subscription.subscriber.name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        <router-link :to="'/users/' + subscriptionPeriod.user.id">
          {{ subscriptionPeriod.user.full_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ subscriptionPeriod.price | price }}
      </td>
    </template>

    <template v-slot:foot="{ data: subscriptionPeriods }">
      <tfoot v-if="subscriptionPeriods.length">
      <tr>
        <td colspan="3" class="text-right">
          <b>
            Total
          </b>
        </td>

        <td>
          <b>
            {{ getTotalPrice(subscriptionPeriods) | price }}
          </b>
        </td>
      </tr>
      </tfoot>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: { ExternalQueryList},

  props: {
    project: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 8, text: 'Name'},
        {width: 8, text: 'User'},
        {width: 4, text: 'Price'},
      ]
    }
  },

  methods:{
    getTotalPrice(subscriptionPeriods) {
      return subscriptionPeriods.reduce((total, subscriptionPeriod) => {
        return total + subscriptionPeriod.price
      }, 0)
    },

    getUrl(subscriptionPeriod) {
      return '/' + subscriptionPeriod.subscription.subscriber_type + '/' + subscriptionPeriod.subscription.subscriber_id + '/subscriptions/' + subscriptionPeriod.subscription.id
    }
  },
}
</script>
